export default "__VITE_ASSET__1abbd609__"